import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classes from './HelpService.module.scss';
import { Chat } from '@icons';
import classNames from 'classnames';
import { helpServiceChat } from '@configs/common';
const HelpService = ({ className }) => (_jsxs("a", { href: helpServiceChat.href, target: "_blank", className: classNames(classes.container, className), children: [_jsx("span", { className: classes.iconWrap, children: _jsx(Chat, { containerClasses: classes.icon }) }), _jsx("p", { className: classes.text, children: _jsx("span", { children: helpServiceChat.text }) })] }));
export default HelpService;
